module.exports = __webpack_public_path__ + "media/images/matrix_preview_landscape-5da4777e5cab859073dbbc1aa580ce1e.png";